<template>
  <div class="nav">
    <div class="nav_top_search">
      <div class="nav_search_box">
        <select @change="changeSearchType($event)" v-model="type" class="select">
          <option value="1">设备名称</option>
          <option value="2">合同编码</option>
        </select>
        <div class="search_input">
          <input @blur="onBlurSerch($event)" name="keyword" v-model="keyword" class="input"
            placeholder="搜索设备..." />
          <div v-if="keyword" @click="searchList" class="search text">
            搜索
          </div>
          <div v-else class="search">
            <img class="icon" src="@/assets/img/search.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="nav_top_title">
      <div class="title_wrap">
        <p class="title">设备列表</p>
        <span class="num">{{ videoList.length > 0 ? videoList.length : 0 }}</span>
      </div>
      <div class="refresh_fun" @click="onRefresh()" title="刷新">
        <img class="icon" src="@/assets/img/refresh.png" />
      </div>
    </div>
    <div class="nav_middle_video" @scroll="scroll($event)" @mousewheel="mousewheel($event)"
      @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
      <div class="no_data" v-if="videoList.length == 0">
        <svg class="empty_icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="12" width="48" height="36" rx="4" stroke="#334155" stroke-width="2"/>
          <circle cx="26" cy="30" r="6" stroke="#334155" stroke-width="2"/>
          <path d="M34 26L44 20V40L34 34" stroke="#334155" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 56H44" stroke="#334155" stroke-width="2" stroke-linecap="round" stroke-dasharray="4 4"/>
        </svg>
        <p>暂无数据</p>
      </div>
      <template v-else>
        <div :class="(currentVideo.name === item.name && currentVideo.device_code == item.device_code) ? 'on' : ''"
          @dblclick.prevent="selectCurrentVideo(item)" @click="selectVideo(item)" class="video_item"
          v-for="item in videoList">
          <div class="info">
            <p class="name">{{ item.name }}</p>
            <p class="title">{{ item.device_code }}</p>
          </div>
          <div class="opera" @click.prevent="selectVideoEdit(item)">
            <div class="edit">
              <img class="icon" src="@/assets/img/edit.png" />
            </div>
          </div>
        </div>
        <div class="spinner-box" v-if="loading">
          <div class="pulse-container">
            <div class="pulse-bubble pulse-bubble-1"></div>
            <div class="pulse-bubble pulse-bubble-2"></div>
            <div class="pulse-bubble pulse-bubble-3"></div>
          </div>
        </div>
      </template>
    </div>
    <!--
    <div class="nav_bottom_statics">
      <div class="item">
        <span class="number">0</span>
        <p class="name">监管货</p>
      </div>
      <div class="hr"></div>
      <div class="item">
        <span class="number">0</span>
        <p class="name">到期拔卡</p>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import eventCommon from './eventCommon.js';
import axios from 'axios';
export default {
  name: 'ContentLeftCmp',
  data() {
    return {
      videoList: [],
      page: 1,
      loading: false,
      currentVideo: {},
      keyword: '',
      type: 1
    }
  },
  mounted() {
    this.getLive();
    eventCommon.$on('onEditDeviceName', (res) => {
      let videoList = this.videoList;
      for (let i = 0; i < videoList.length; i++) {
        if (videoList[i].device_code == res.device_code && videoList[i].channel_id == res.channel_id) {
          this.videoList[i].name = res.device_name;
          this.videoList[i].channel_name = res.channel_name;
          break;
        }
      }
    })
  },
  methods: {
    changeSearchType(e) {
      this.type = e.target.value;
    },
    onBlurSerch() {
      let keyword = this.keyword;
      if (!keyword || keyword == '') {
        this.getLive(1, true);
      }
    },
    searchList() {
      this.getLive(1, true);
    },
    onRefresh() {
      this.getLive(1, true);
    },
    getLive(page = 1, isSearch = false) {
      let _this = this;
      if (_this.loading) return;
      _this.loading = true;
      let keyword = _this.keyword;
      let type = _this.type;
      axios.get(_this.$store.state.base_url + 'Extendquery2/getProjectMonitor?page=' + page + '&keyword=' + keyword + '&type=' + type).then(function (response) {
        _this.loading = false;
        if (response.status === 200 && response.data.code == 1) {
          if (page == 1 && keyword && keyword != '') {
            _this.$store.dispatch("doChangeLoop", false);
          }
          if (response.data.list.length > 0) {
            if (page == 1) {
              _this.videoList = response.data.list
            } else {
              let videoList = _this.videoList;
              _this.videoList = videoList.concat(response.data.list)
            }
            _this.page = page + response.data.list.length;
          } else {
            if (page == 1) {
              _this.videoList = [];
            }
            _this.page = -1;
          }
          if (isSearch) {
            eventCommon.$emit('onSearchList', keyword)
          }
        }
      }).catch(function (error) {
        _this.loading = false;
      }).finally(function () { });
    },
    touchStart(e) {
      console.log(e);
    },
    touchMove(e) {
      console.log(e);
    },
    touchEnd(e) {
      console.log(e);
    },
    mousewheel(e) {
    },
    scroll(e) {
      let scrollHeight = parseInt(e.target.scrollHeight);
      let clientHeight = parseInt(e.target.clientHeight);
      let scrollTop = parseInt(e.target.scrollTop);
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        let page = this.page;
        if (page > 0) {
          this.getLive(page);
        }
      }
    },
    selectVideo(item) {
      this.currentVideo = item;
    },
    selectCurrentVideo(item) {
      eventCommon.$emit('onSelectVideo', item)
    },
    selectVideoEdit(item) {
      eventCommon.$emit('onShowVideoDetail', item)
    }
  }
}
</script>

<style scoped>
.nav {
  width: 100%;
  height: 100%;
  background: transparent;
  display: flex;
  flex-direction: column;
}

.nav_top_search {
  padding: 12px;
  flex-shrink: 0;
}

.nav_search_box {
  display: flex;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.3s;
}

.nav_search_box:focus-within {
  border-color: #3b82f6;
}

.nav_search_box .select {
  width: 80px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  background: transparent;
  border: none;
  border-right: 1px solid #334155;
  color: #94a3b8;
  padding: 0 8px;
  cursor: pointer;
}

.nav_search_box .search_input {
  flex: 1;
  display: flex;
  align-items: center;
}

.nav_search_box .search_input .input {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 13px;
  background: transparent;
  border: none;
  padding: 0 10px;
  color: #e2e8f0;
}

.nav_search_box .search_input .input::placeholder {
  color: #64748b;
}

.nav_search_box .search_input .search {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.nav_search_box .search_input .search.text {
  width: 46px;
  background: #3b82f6;
  color: white;
  font-size: 12px;
  font-weight: 500;
  border-radius: 0 6px 6px 0;
}

.nav_search_box .search_input .search .icon {
  width: 14px;
  height: 14px;
  opacity: 0.5;
}

.nav_top_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  height: 40px;
}

.title_wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav_top_title .title {
  font-size: 14px;
  color: #e2e8f0;
  font-weight: 600;
}

.nav_top_title .num {
  font-size: 12px;
  color: #64748b;
}

.nav_top_title .refresh_fun {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav_top_title .refresh_fun:hover {
  background: #1e293b;
}

.nav_top_title .refresh_fun .icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
  transition: opacity 0.3s;
}

.nav_top_title .refresh_fun:hover .icon {
  opacity: 1;
}

.nav_middle_video {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.nav_middle_video .video_item {
  margin-bottom: 6px;
  padding: 10px 12px;
  background: #1e293b;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.25s ease;
}

.nav_middle_video .video_item:hover {
  background: #26354d;
  border-color: #334155;
}

.nav_middle_video .video_item.on {
  background: rgba(59, 130, 246, 0.1);
  border-color: #3b82f6;
}

.nav_middle_video .video_item .info {
  flex: 1;
  min-width: 0;
}

.nav_middle_video .video_item .name {
  font-size: 14px;
  font-weight: 500;
  color: #e2e8f0;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav_middle_video .video_item .title {
  font-size: 11px;
  color: #64748b;
  line-height: 18px;
  margin-top: 2px;
}

.nav_middle_video .video_item .opera {
  flex-shrink: 0;
  margin-left: 8px;
}

.nav_middle_video .video_item .opera .edit {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: background 0.3s;
}

.nav_middle_video .video_item .opera .edit:hover {
  background: #334155;
}

.nav_middle_video .video_item .opera .edit .icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
  transition: opacity 0.3s;
}

.nav_middle_video .video_item .opera .edit:hover .icon {
  opacity: 1;
}

.nav_bottom_statics {
  padding: 12px;
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav_bottom_statics .item {
  flex: 1;
  text-align: center;
}

.nav_bottom_statics .item .name {
  font-size: 11px;
  line-height: 18px;
  color: #94a3b8;
  margin-top: 2px;
}

.nav_bottom_statics .item .number {
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  color: #e2e8f0;
}

.nav_bottom_statics .hr {
  width: 1px;
  height: 28px;
  background: #1e293b;
}

.spinner-box {
  background-color: transparent;
  width: 100%;
  padding: 10px 0;
}

.pulse-container {
  display: table;
  margin: 0 auto;
}

.pulse-bubble {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #3b82f6;
  float: left;
}

.pulse-bubble-1 {
  animation: pulse .4s ease 0s infinite alternate;
  margin-right: 8px;
}

.pulse-bubble-2 {
  animation: pulse .4s ease .2s infinite alternate;
}

.pulse-bubble-3 {
  animation: pulse .4s ease .4s infinite alternate;
  margin-left: 8px;
}

@keyframes pulse {
  from {
    opacity: 1;
    transform: scale(1);
  }

  to {
    opacity: .25;
    transform: scale(.75);
  }
}

.no_data {
  width: 100%;
  padding: 60px 20px;
  text-align: center;
}

.no_data .empty_icon {
  width: 64px;
  height: 64px;
  opacity: 0.6;
}

.no_data p {
  font-size: 13px;
  color: #64748b;
  line-height: 40px;
}
</style>
